import { observer } from 'mobx-react'
import { ReactComponent as Heart } from '../../../../assets/Vector.svg'
import './index.scss'
import { NumberCountWrapper } from '../../../common/NumberCount'
import Parallax from '../../../common/Parallax'
import Eco from '../Eco'
import Cooperations from '../Cooperations'
import ContentState from '../../../../stores/ContentState'
import Future from '../Future'
import Product from '../Product'
import { useEffect, useState } from 'react'
const Friendly = observer(() => {
  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])
  const hearts = (count: number) => {
    return Array(count).fill(0)
  }

  const getClass = (id: number) => {
    const classes = [
      'topright',
      'topleft',
      'bottomright',
      'middlebottomleft',
      'bottomleft',
      'middlebottomright',
      'up',
      'down',
      'middletopleft',
      'right',
      'left',
      'middletopright',
    ]

    return classes[
      id >= classes.length ? Math.floor(id / classes.length) - 1 : id
    ]
  }

  if (!ContentState.about?.friendly) return <></>

  return (
    <section className="friendly-block" id="friendly">
      <div className="friendly-block__container">
        <div className="friendly-block__title">
          <span
            dangerouslySetInnerHTML={{
              __html: ContentState.about.friendly.title,
            }}
          ></span>
          <span className="anim-block">
            <Heart className="friendly-block__heart" />
            <span className="hearts">
              {hearts(20).map((h, i) => (
                <Heart key={i} className={getClass(i)} />
              ))}
            </span>
          </span>
        </div>
        <div className="friendly-block__row">
          <div className="friendly-block__img">
            <Parallax
              src={
                ContentState.about.friendly.video
                  ? ContentState.about.friendly.video!
                  : width > 900
                  ? ContentState.about.friendly.imgDesk!
                  : ContentState.about.friendly.imgMob!
              }
              type={ContentState.about.friendly.video ? 'video' : 'img'}
              poster={
                ContentState.about.friendly.video
                  ? ContentState.about.friendly.poster
                  : ''
              }
            />
          </div>
          <div className="friendly-block__col">
            <div style={{ overflow: 'hidden' }}>
              <div
                className="friendly-block__text"
                dangerouslySetInnerHTML={{
                  __html: ContentState.about.friendly.text,
                }}
              ></div>
            </div>
            <div style={{ overflow: 'hidden' }}>
              <div className="we-block__list">
                {ContentState.about.friendly.list?.map((l, i) => (
                  <div className="we-block__item" key={i}>
                    <div className="we-block__item-num">
                      <NumberCountWrapper final={l.count} end={l.end} />
                    </div>
                    <div className="we-block__item-text">{l.text} </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <Eco />
        <Product />
        <Future />
      </div>
    </section>
  )
})

export default Friendly
